import {TOptions} from 'i18next';
import {tAsString} from './tAsString';

export function tWithoutHtml(key: string, options: TOptions = {}): string {
    return tAsString(key, options).replace(/<.+?>/g, '');
}
